module.exports = __webpack_public_path__ + "img/tab204.85af4b2c.png";